function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "IntegrationHubspot_svg__5_a",
  x1: "41.218%",
  x2: "29.427%",
  y1: "10.394%",
  y2: "88.38%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#77C9FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#45B1FF"
})), React.createElement("linearGradient", {
  id: "IntegrationHubspot_svg__6_b",
  x1: "38.46%",
  x2: "22.966%",
  y1: "20.191%",
  y2: "78.887%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1BA5FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#148EFC"
})), React.createElement("linearGradient", {
  id: "IntegrationHubspot_svg__7_c",
  x1: "15.818%",
  x2: "50%",
  y1: "119.797%",
  y2: "29.978%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F7FE"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FAFBFC"
})), React.createElement("linearGradient", {
  id: "IntegrationHubspot_svg__8_d",
  x1: "37.509%",
  x2: "60.312%",
  y1: "92.192%",
  y2: "12.233%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#DAE4EC"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E9EFF4"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "url(#IntegrationHubspot_svg__5_a)",
  d: "M22.394 18a4.39 4.39 0 01-1.972 3.667l5.516 5.514c.34.34.366.876.078 1.247l-.078.089-5.452 5.453a3.516 3.516 0 01-4.822.142l-.15-.142-7.242-7.243 12.296-12.294A4.389 4.389 0 0122.394 18z"
}), React.createElement("path", {
  fill: "url(#IntegrationHubspot_svg__6_b)",
  d: "M8.728 9.982l.09.079 5.515 5.516A4.39 4.39 0 0118 13.606a4.38 4.38 0 013.107 1.287L8.772 27.228 2.03 20.486a3.516 3.516 0 01-.142-4.822l.142-.15 5.452-5.453a.944.944 0 011.246-.079z"
}), React.createElement("path", {
  fill: "url(#IntegrationHubspot_svg__7_c)",
  d: "M20.336 1.888l.15.142 6.742 6.742-4.878 4.878A6.133 6.133 0 0018 11.848a6.125 6.125 0 00-3.684 1.224l-4.255-4.255a.944.944 0 01-.079-1.246l.079-.09 5.453-5.451a3.516 3.516 0 014.665-.274l.157.132z"
}), React.createElement("path", {
  fill: "url(#IntegrationHubspot_svg__8_d)",
  d: "M27.228 8.772l6.742 6.742a3.516 3.516 0 01.142 4.822l-.142.15-5.453 5.452a.945.945 0 01-1.247.078l-.089-.078-4.253-4.254A6.125 6.125 0 0024.152 18a6.133 6.133 0 00-1.802-4.35l4.878-4.878z"
}), React.createElement("path", {
  d: "M10.061 7.482l5.453-5.452a3.516 3.516 0 014.822-.142l.15.142L33.97 15.514a3.516 3.516 0 01.142 4.822l-.142.15-5.453 5.452a.945.945 0 01-1.247.078l-.089-.078-4.253-4.254a6.152 6.152 0 00-8.611-8.612L10.06 8.817a.944.944 0 01-.079-1.246l.079-.09 5.453-5.451-5.453 5.452z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M22.807 18h8.386c1.671 0 2.277.174 2.889.5.61.328 1.09.807 1.417 1.418.327.612.501 1.218.501 2.89v8.385c0 1.671-.174 2.277-.5 2.889a3.407 3.407 0 01-1.418 1.417c-.612.327-1.218.501-2.89.501h-8.385c-1.671 0-2.277-.174-2.889-.5a3.407 3.407 0 01-1.417-1.418c-.327-.612-.501-1.218-.501-2.89v-8.385c0-1.671.174-2.277.5-2.889a3.407 3.407 0 011.418-1.417c.612-.327 1.218-.501 2.89-.501z"
}), React.createElement("path", {
  fill: "#FF7A59",
  d: "M30.052 25.064v-1.47c.397-.185.65-.582.653-1.02v-.034c0-.625-.507-1.132-1.132-1.132h-.034c-.625 0-1.132.507-1.132 1.132v.034c.002.438.257.835.653 1.02v1.47a3.205 3.205 0 00-1.524.67l-4.03-3.139c.028-.103.043-.21.044-.318a1.275 1.275 0 10-1.276 1.273c.22 0 .437-.06.627-.17l3.97 3.088a3.215 3.215 0 00.05 3.622l-1.208 1.207a1.037 1.037 0 00-.302-.049 1.047 1.047 0 101.048 1.048 1.034 1.034 0 00-.049-.302l1.195-1.194a3.22 3.22 0 102.447-5.736m-.495 4.834a1.652 1.652 0 110-3.304 1.652 1.652 0 01.002 3.303"
}), React.createElement("path", {
  d: "M20.336 1.888l.15.142L33.97 15.514a3.515 3.515 0 01.87 3.535c.262.248.483.54.66.87.326.61.5 1.217.5 2.888v8.386c0 1.671-.174 2.277-.5 2.889a3.407 3.407 0 01-1.418 1.417c-.612.327-1.218.501-2.89.501h-8.385c-1.671 0-2.277-.174-2.889-.5a3.436 3.436 0 01-.87-.66 3.513 3.513 0 01-3.384-.728l-.15-.142L2.03 20.486a3.516 3.516 0 01-.142-4.822l.142-.15 5.452-5.453a.944.944 0 011.246-.079l.09.079 5.515 5.516A4.394 4.394 0 0122.393 18h1.759a6.152 6.152 0 00-9.836-4.928l-4.255-4.255a.944.944 0 01-.079-1.246l.079-.09 5.453-5.451a3.516 3.516 0 014.822-.142z"
}));

var SvgIntegrationHubspot = function SvgIntegrationHubspot(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _ref, _ref2);
};

export default SvgIntegrationHubspot;